import React from "react";
import {
    WORDPRESS_URL,
} from "../settings";

const cachedContent: {
    [key: string]: string | undefined;
} = {};

interface IProps {
    alternateContent?: JSX.Element;
    loadingContent?: JSX.Element;
    selector?: string;
    slug?: string;
    url?: string;
    useInnerHTML?: boolean;
}

interface IState {
    html?: string;
    loading: boolean;
}

interface IWordpressPageResponse {
    author: number;
    comment_status: string;
    content: {
        protected: boolean;
        rendered: string;
    };
    date: string;
    date_gmt: string;
    excerpt: {
        protected: false;
        rendered: string;
    };
    featured_media: number;
    guid: {
        rendered: string;
    };
    id: number;
    link: string;
    menu_order: number;
    meta: string[];
    modified: string;
    modified_gmt: string;
    parent: number;
    ping_status: string;
    slug: string;
    status: string;
    template: string;
    title: {
        rendered: string;
    };
    type: string;
}

export default class EmbedWordpress extends React.Component<IProps, IState> {
    public state: IState = {
        loading: true,
    };
    public componentDidMount(): void {
        const { slug, url } = this.props;
        if (slug) {
            this.fetchWordpressPage();
        } else if (url) {
            this.fetchWordpressUrlContent();
        }
    }

    public render(): JSX.Element | null {
        const {
            alternateContent,
            loadingContent,
        } = this.props;
        const {
            loading,
            html,
        } = this.state;

        if (loading && loadingContent) {
            return loadingContent;
        }

        if (!html) {
            if (alternateContent) {
                return alternateContent;
            } else {
                // tslint:disable-next-line:no-null-keyword
                return null;
            }
        }

        return (
            <div dangerouslySetInnerHTML={ { __html: html } }></div>
        );
    }

    protected async fetchWordpressPage(): Promise<void> {
        const { slug } = this.props;
        const url = `${ WORDPRESS_URL }wp-json/wp/v2/pages/?slug=${ slug }`;

        if (cachedContent[url] === undefined) {
            const response = await fetch(url, {
                cache: "force-cache",
                method: "GET",
                mode: "cors",
            });

            const data = (await response.json()) as IWordpressPageResponse[];
            if (!data) {
                return;
            }

            const page = data[0];
            if (!page) {
                cachedContent[url] = "";
                return;
            }

            cachedContent[url] = page.content.rendered;
        }

        this.setState({
            html: cachedContent[url],
            loading: false,
        });
    }

    protected async fetchWordpressUrlContent(): Promise<void> {
        const { url } = this.props;
        if (!url) {
            return;
        }

        if (cachedContent[url] === undefined) {
            const response = await fetch(url, {
                cache: "force-cache",
                method: "GET",
                mode: "cors",
            });

            const fetchedContent = await response.text();
            cachedContent[url] = fetchedContent;
        }

        // Load the content into searchable DOM nodes
        const content = cachedContent[url];
        if (!content) {
            return;
        }

        const { selector } = this.props;
        if (!selector) {
            this.setState({
                html: content,
                loading: false,
            });
            return;
        }

        // TODO Use selector to find the node you wanted
        const dom = document.createElement("div");
        dom.innerHTML = content;
        const node = dom.querySelector(selector);

        if (!node) {
            return;
        }

        // TODO Using innerHTML flag, decide whether it should return content or the innerHTML
        const { useInnerHTML } = this.props;
        this.setState({
            html: useInnerHTML ? node.outerHTML : node.innerHTML,
            loading: false,
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/EmbedWordpress.tsx